<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">
  <a  routerLink="/">
    <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
  </a>

  <span class="text-color-white">Set Apex Id</span>

</mat-toolbar>
<mat-card class="example-card" style="margin-top: 10px;">
    <mat-card-content>
        <h2 class="example-h2">Configuration</h2>

        <section class="example-section">
            
            <mat-form-field>
                <mat-label>APEX ID</mat-label>
                <input matInput required [(ngModel)]="apexIdInput" [disabled]="apexIdOverrideStatus">
            </mat-form-field>
        </section>
        
        <section class="example-section">
            <mat-slide-toggle class="example-margin" [color]="color" [(ngModel)]="apexIdOverrideStatus" [disabled]="apexIdInput === ''" (change)="apexIdOverrideToggleChange($event)">
                Override APEX ID!
            </mat-slide-toggle>
        </section>

    </mat-card-content>
</mat-card>

<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>

<mat-card class="example-card" *ngIf="!isLoading">
    <mat-card-content>
      <h2 class="example-h2">Current Configuration</h2>
      <section class="example-section">
        <label class="example-margin">Override Status:</label>
        <span>{{ apexIdOverrideStatus ? 'Yes' : 'No' }}</span>
      </section>
      <section class="example-section">
        <label class="example-margin">Current APEX ID:</label>
        <span>{{ apexIdInput }}</span>
      </section>
      <section class="example-section">
        <label class="example-margin">Current Business Type:</label>
        <span>{{ businessType }}</span>
      </section>
      <section class="example-section">
        <label class="example-margin">Current Country:</label>
        <span>{{ country }}</span>
      </section>    
    </mat-card-content>
</mat-card>


